export default __webpack_public_path__ + "static/media/twitter_logo.58bf1288.svg";